import { useContext } from 'react';
import CampaignOrderContext from './CampaignOrderProvider';

export const useCampaignOrderContext = () => {
  const context = useContext(CampaignOrderContext);
  if (context === undefined) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
};
